module.exports = __webpack_public_path__ + "img/primal.42abf605.png";